import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import ForgetPasswordHook from "../../hook/auth/forget-password-hook";
import ValidTORMessages from "./ValidMessages/ValidMessages";
import { validateEmail } from "../../Feature/EmailValidRegex";
const ForgetPasswordPage = () => {
  const [OnChangeEmail, email, onSubmit, isComplate] = ForgetPasswordHook();
  return (
    <Container style={{ minHeight: "690px" }}>
      <Row className="py-5 d-flex justify-content-center ">
        <Col sm="12" className="d-flex flex-column ">
          <label className="mx-auto title-login">نسيت كلمة السر</label>
          <input
            value={email}
            onChange={OnChangeEmail}
            placeholder="ادخل الايميل..."
            type="email"
            className="user-input my-3 text-center mx-auto"
          />
          <div className="mx-auto mt-2">
            {email.length > 1 ? (
              <ValidTORMessages validlistError={validateEmail(email)} />
            ) : null}
          </div>

          {isComplate ? (
            <button onClick={onSubmit} className="btn-login mx-auto mt-2">
              ارسال الكود
            </button>
          ) : (
            <button
              disabled
              className="bg-grey-500 btn  mx-auto mt-2"
              style={{
                cursor: "not-allowed",
              }}
            >
              ارسال الكود
            </button>
          )}
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default ForgetPasswordPage;
